// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/questions',
    name: 'Questions',
    component: layout,
    redirect: '/questions/index',
    meta: {
      title: '问答快照',
      icon: 'i-menu:questions',
      i18Key: 'router.user.questions.title',
      roles: [1]
    },
    sort: 40,
    children: [
      {
        path: 'index',
        name: 'QuestionsIndex',
        component: () => import('@/views/Questions/Index.vue'),
        meta: {
          title: '问答快照',
          icon: 'i-menu:questions',
          i18Key: 'router.user.questions.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtnDateOnly', 'questionBtn']
        }
      }
    ]
  }
]
export default routes
